<script>
    import {createEventDispatcher} from "svelte";
    import {user} from "./admin-store";
    import BlogForm from "./BlogForm.svelte";
    import PhotoForm from "./PhotoForm.svelte";
    import Button from "../../components/ui/Button.svelte";

    const dispatch = createEventDispatcher();
    let formComponent = null;

    function setEditPage(page) {
        formComponent = page;
    }
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<div class="parent">
    <div class="menu">
        <div>
            <Button clazz="menu" on:click={() => {setEditPage(BlogForm)}}>Manage Blogs</Button>
            <Button clazz="menu" on:click={() => {setEditPage(PhotoForm)}}>Manage Photos</Button>
        </div>

        <div>
            <span class="loggedUser">{$user}</span>
            <Button clazz="menu" on:click={() => {dispatch('signout')}}>Sign out</Button>
        </div>
    </div>

    <div class="compo">
        <svelte:component this={formComponent}/>
    </div>
</div>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .parent {
        position: relative;
    }
    .menu {
        position: absolute;
        top: -2rem;
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 60px;
        align-items: center;
        background-color: var(--mid-grey);
        color: var(--white-color);
        border-radius: 5px;
        padding: 0 1rem;
    }

    .loggedUser {
        font-size: .9rem;
        padding: 0 2px;
    }

    .compo {
        padding-top: 4rem;
    }
</style>